export const getPercentageSaving = ({
  price,
  wasPrice,
}: {
  price: string;
  wasPrice?: number;
}): string | undefined => {
  if (wasPrice) {
    const saving = Number.parseFloat((wasPrice - Number.parseFloat(price)).toFixed(2));
    return ((saving / wasPrice) * 100).toFixed(0);
  }
  return undefined;
};
